export default __webpack_public_path__ + "static/media/slider_image_03-md@1x.500b9cb5.jpg";